export { SpaTreatmentsConnected as SpaTreatments } from './container';
